<video
  #videoElement
  [src]="url$ | async"
  preload="metadata"
  playsinline
  webkit-playsinline
  controls
  [attr.data-testid]="'video-player'"
></video>
